<template>
    <div style="position:relative; top:150px;">
        <content-header
            icona="fas fa-industry"
            titolo="Dati aziendali"
        ></content-header>

        <div class="card sn-card-contenuto">
            <div class="card-body">

            
                <!-- *** EDIT ANAGRAFICA CLIENTE *** -->
                <div class="card">
                <div class="card-header">
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(true)">Salva</button>&nbsp;
                </div>
                <div class="card-body">

                    <form autocomplete="off">

                    <messaggio-standard 
                        :mostraMessaggio="mostraMessaggio"
                        :alertClass="alertClass"
                        :alertIcon="alertIcon"
                        :alertIconSpin="alertIconSpin"
                        :alertMessaggio="alertMessaggio"
                        fontawesome="standard"
                        ></messaggio-standard>
                        
                    <div class="row rigaSezioneForm">
                        <div class="col-md">
                            <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Ragione Sociale</label>
                        <input type="text" class="form-control" readonly v-model="oAnagrafica.ana_ragioneSociale">
                    </div>
                    

                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Indirizzo</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_indirizzo">
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Città</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_citta">
                        </div>
                        <div class="col-md-2 mb-3">
                            <label class="form-label">Provincia</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_prov">
                        </div>
                        <div class="col-md-2 mb-3">
                            <label class="form-label">CAP</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_cap">
                        </div>
                        
                    </div>

                    <div class="row rigaSezioneForm">
                        <div class="col-md">
                            <i class="fas fa-envelope text-primary"></i>&nbsp;Informazioni di contatto
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Telefono</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_tel">
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Cellulare</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_cell">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3 mb-3">
                            <label class="form-label">Email</label>
                            <input type="email" class="form-control" v-model="oAnagrafica.ana_email">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="form-label">PEC</label>
                            <input type="email" class="form-control" v-model="oAnagrafica.ana_pec">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Sito Web</label>
                            <input type="url" class="form-control" v-model="oAnagrafica.ana_sito">
                        </div>

                    </div>

                    <div class="row rigaSezioneForm">
                        <div class="col-md">
                            <i class="fas fa-gavel text-success"></i>&nbsp;Dati fiscali
                        </div>
                    </div>

                    <div class="row">   
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Codice Fiscale</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_cf">
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Partita IVA</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_piva">
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Codice SDI</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_codSdi">
                        </div>
                    </div>

                    </form>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(true)">Salva</button>&nbsp;
                </div>
                </div>

            </div>
        </div>

    </div>
  
    
       
    
</template>

<script>
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStandard from '@/components/MessaggioStandard.vue';
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'DatiAziendaliView',
    components: {
        ContentHeader, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtVSAnagrafica: [],

            oAnagrafica: {
                ana_id: -1,
                ana_cognome: "",
                ana_nome: "",
                ana_ragioneSociale: "",
                ana_indirizzo: "",
                ana_citta: "",
                ana_cap: "",
                ana_tel: "",
                ana_cell: "",
                ana_email: "",
                ana_pec: "",
                ana_sito: "",
                ana_cf: "",
                ana_piva: "",
                ana_codSdi: "",
                ana_note: "",
                ana_prov: "",
                ana_username: "",
                ana_password: "",
                ana_lastLogin: new Date(1900,1,1),

                token: "",
            },
         

            mostraGrigliaAnagrafica: true,
            mostraEditAnagrafica: false,
            mostraEditPersonale: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false


        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
               
        ClearAnagrafica() {
            this.oAnagrafica = {
                ana_id: -1,
                ana_cognome: "",
                ana_nome: "",
                ana_ragioneSociale: "",
                ana_indirizzo: "",
                ana_citta: "",
                ana_cap: "",
                ana_tel: "",
                ana_cell: "",
                ana_email: "",
                ana_pec: "",
                ana_sito: "",
                ana_cf: "",
                ana_piva: "",
                ana_codSdi: "",
                ana_note: "",
                ana_prov: "",
                ana_username: "",
                ana_password: "",
                ana_lastLogin: new Date(1900,1,1), 
                
                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        
        // *** OPERAZIONI DI BASE SU Anagrafica
        GetElemAnagrafica(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/GetElemAnagraficaClienti?token=" + this.$store.state.UserInfo.token + "&id=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oAnagrafica = obj;

                this.mostraGrigliaAnagrafica=false;
                this.mostraEditAnagrafica= true;

                this.$store.commit('Messaggio', {parms: [true, ['Anagrafica caricata.'], 'alert alert-success', 'fa-check', false, 2000]});

            });
        },

        SalvaAnagrafica(reload) {
            let oSubmit = [];
            oSubmit = this.oAnagrafica;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/SalvaAnagraficaClienti", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                       
                        this.GetElemAnagrafica(obj.dati[0]);
                       
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetElemAnagrafica(this.$store.state.UserInfo.id);

    }
}
</script>